import styled from "styled-components";
import { SectionSubtitle, SectionTitle } from "components/Style";
import { TECHNOLOGY_DESC } from "appLauncher";

const TechnologySection = styled.section`
  padding: 80px 0;
  background-color: #fff;
`;
const TechnologyContainer = styled.div`
  max-width: 1280px;
  margin: 0 auto;
  padding: 0 15px;
`;
const TechnologyContent = styled.p`
  font-size: 1.1rem;
  line-height: 1.8;
  color: #666;
  text-align: center;
  margin-bottom: 40px;
`;

const TechnologyImageContainer = styled.div`
  display: flex;
  justify-content: center;
  margin-bottom: 40px;
`;

const TechnologyImagePlaceholder = styled.div`
  width: 1200px;
  height: 566px;
  background: #eee;
  border-radius: 8px;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.08);
  display: flex;
  align-items: center;
  justify-content: center;
  color: #2640ed;
  font-size: 28px;
  font-weight: 500;
`;

export default function TechnologySectionComponent() {
  return (
    <TechnologySection>
      <TechnologyContainer>
        <SectionTitle>整体技术方案</SectionTitle>
        <SectionSubtitle>Comprehensive Technical Solution</SectionSubtitle>
        <TechnologyContent>{TECHNOLOGY_DESC}</TechnologyContent>
        <TechnologyImageContainer>
          <TechnologyImagePlaceholder>
            <img src="/assets/about/system.png" />
          </TechnologyImagePlaceholder>
        </TechnologyImageContainer>
      </TechnologyContainer>
    </TechnologySection>
  );
}
